import { getTreatmentDaysCountDefaultValue } from '~libs.shared.prescription';

import { TreatmentDaysNumberInput } from '../../prescription/treatmentDaysCount/TreatmentDaysNumberInput';
import { DraftPrescriptionsFormController } from '../DraftPrescriptionsForm.types';

import { DraftStandardPrescriptionFieldName } from './DraftStandardPrescriptionField.types';

type DraftStandardPrescriptionTreatmentDaysSlotProps = Pick<
   DraftPrescriptionsFormController,
   'register' | 'trigger'
> & {
   readonly name: DraftStandardPrescriptionFieldName;
   readonly extendedDosageActive: boolean;
   readonly extendedDosageTreatmentDaysCount: number | undefined;
   readonly initialTreatmentDaysCount: number | null | undefined;
   readonly medicineSufficiencyCount: number | undefined;
   readonly underTreatmentSupervision: boolean;
   readonly maxValue: number;
   readonly exceeded: boolean;
   readonly editable: boolean;
};

export const DraftStandardPrescriptionTreatmentDaysSlot = (
   props: DraftStandardPrescriptionTreatmentDaysSlotProps
): JSX.Element => {
   return (
      <TreatmentDaysNumberInput
         register={props.register}
         trigger={props.trigger}
         name={props.name}
         defaultValue={
            props.extendedDosageActive
               ? props.extendedDosageTreatmentDaysCount ?? null
               : getTreatmentDaysCountDefaultValue(props.initialTreatmentDaysCount, props.medicineSufficiencyCount)
         }
         underTreatmentSupervision={props.underTreatmentSupervision}
         maxValue={props.maxValue}
         exceeded={props.exceeded}
         disabled={props.extendedDosageActive || !props.editable}
      />
   );
};
